import { useEffect, useState } from "react";
import { outbox } from "@/offline/outbox";
import type { QueuedEntry } from "@/offline/outboxStore";

/**
 * Live view of the on-device outbox — the phone-local queue of entries
 * accepted while offline and not yet replayed to the server (of-002/of-003).
 * Read-only: components enqueue through `outbox.enqueue`, never through
 * local state, so there is exactly one source of truth for what's pending.
 */
export function useOutbox(): QueuedEntry[] {
  const [items, setItems] = useState<QueuedEntry[]>([]);

  useEffect(() => {
    let cancelled = false;
    outbox.list().then((list) => {
      if (!cancelled) setItems(list);
    });
    const unsubscribe = outbox.subscribe((list) => {
      if (!cancelled) setItems(list);
    });
    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, []);

  return items;
}
